// extracted by mini-css-extract-plugin
export default {"container":"Fx9Gg","title":"bieo7","paid":"a_PGT","link":"NikKg"};